import moment from "moment";

export const getFormatDateTimeDefault = (
  date: string,
  format: string = "YYYY/MM/DD HH:mm:ss"
) => {
  return moment(date).format(format);
};
